import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import VendorMaster from './components/VendorMaster';
import ProductMaster from './components/ProductMaster';
import LocationMaster from './components/LocationMaster';
import CurrencyMaster from './components/CurrencyMaster';
import TaxMaster from './components/TaxMaster';
import CategoryMaster from './components/CategoryMaster';
import SubcategoryMaster from './components/SubcategoryMaster';
import Profile from './components/Profile';
import ClientMaster from './components/ClientMaster';
import UserMaster from './components/UserMaster';
import RFQItemsMaster from './components/RFQItemsMaster';
import CustomerMaster from './components/CustomerMaster';
import PurchaseOrderItems from './components/PurchaseOrderItems';
import MaterialReciptNote from './components/MaterialReciptNote';
import SalesOrderItems from './components/SalesOrderItems';
import InvoiceItems from './components/DeliveryNoteModal';
import StockInItems from './components/StockInItems';
import StockOutItems from './components/StockOutItems';
import CompanyMaster from './components/CompanyMaster';
import BranchLocation from './components/BranchLocation';
import StockSummaryReport from './components/StockSummaryReport';
import DepartmentMaster from './components/DepartmentMaster';
import MappingMaster from './components/apimappingmaster';
import BOMMaster from './components/BOMMaster';
import ProductionOrderMaster from './components/ProductionOrderMaster';
import IssueForProductionItems from './components/IssueForProductionItems';
import ReceiptFromProductionItems from './components/ReceiptFromProductionItems';
import DashboardBuilder from './components/DashboardBuilder';
import DashboardViewer from './components/DashboardViewer';
import DashboardBuilderMain from './components/DashboardBuilderMain';
import DeliveryNoteModal from './components/DeliveryNoteModal';
import SurveyBOQItems from './components/SurveyBOQItems';
import ProjectItems from './components/ProjectItems';
import FeederList from './components/FeederList';
import MaterialReceiptNote from './components/MaterialReciptNote';
import SiteIndentItems from './components/SiteIndentItems';
import ApprovalMaster from './components/ApprovalMaster';
import MaterialIssueItems from './components/MaterialIssueItems';
import MaterialReceiveItems from './components/MaterialReceiveItems';
import DPRItems from './components/DPRItems';
import MaterialReturnItems from './components/MaterialReturnItems';
import ComparisonReport from './components/ComparisonReport';
import ActivityList from './components/ActivityList';
import SessionService from './components/Sessionservice';



const AuthenticatedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};


function App() {
  
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
         <Route path="/dashboard-builder/:id" element={<DashboardBuilder />} />
         <Route path="/dashboard-view/:id" element={<DashboardViewer />} />
         <Route path="/dashboard-management" element={<DashboardBuilderMain />} />
        {/* <Route path="/company-information" element={<CompanyMaster/>} /> */}
                <Route path="/profile" element={
          <AuthenticatedRoute>
            <Profile />
          </AuthenticatedRoute>
        } />
       
        

        
        {/* Protected Routes with Screen Codes */}
        <Route path="/vendor-master" element={
          <ProtectedRoute screenCode="VENDOR_MASTER">
            <VendorMaster />
          </ProtectedRoute>
        } />
        <Route path="/customer-master" element={
          <ProtectedRoute screenCode="CUSTOMER_MASTER">
            <CustomerMaster />
          </ProtectedRoute>
        } />
        <Route path="/product-master" element={
          <ProtectedRoute screenCode="PRODUCT_MASTER">
            <ProductMaster />
          </ProtectedRoute>
        } />
        <Route path="/location-master" element={
          <ProtectedRoute screenCode="WAREHOUSE">
            <LocationMaster />
          </ProtectedRoute>
        } />
        <Route path="/currency-master" element={
          <ProtectedRoute screenCode="CURRENCY_MASTER">
            <CurrencyMaster />
          </ProtectedRoute>
        } />
        <Route path="/tax-master" element={
          <ProtectedRoute screenCode="TAX_MASTER">
            <TaxMaster />
          </ProtectedRoute>
        } />
        <Route path="/category-master" element={
          <ProtectedRoute screenCode="CATEGORY">
            <CategoryMaster />
          </ProtectedRoute>
        } />
        <Route path="/subcategory-master" element={
          <ProtectedRoute screenCode="SUBCATEGORY">
            <SubcategoryMaster />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute screenCode="PROFILE">
            <Profile />
          </ProtectedRoute>
        } />
        {/* <Route path="/client-master" element={
          <ProtectedRoute screenCode="CLIENT">
            <ClientMaster />
          </ProtectedRoute>
        } /> */}
        <Route path="/user-master" element={
          <ProtectedRoute screenCode="USER_MASTER">
            <UserMaster />
          </ProtectedRoute>
        } />
        <Route path="/rfq-items-master" element={
          <ProtectedRoute screenCode="RFQ_MASTER">
            <RFQItemsMaster />
          </ProtectedRoute>
        } />
        <Route path="/purchase-order-items" element={
          <ProtectedRoute screenCode="PURCHASE_ORDER">
            <PurchaseOrderItems />
          </ProtectedRoute>
        } />
        <Route path="/Material-Receipt-Note" element={
          <ProtectedRoute screenCode="MRN_MASTER">
            <MaterialReceiptNote />
          </ProtectedRoute>
        } />
        <Route path="/sales-master" element={
          <ProtectedRoute screenCode="SALES_ORDER">
            <SalesOrderItems />
          </ProtectedRoute>
        } />
        <Route path="/delivery-note" element={
          <ProtectedRoute screenCode="DELIVERY_NOTE">
            <DeliveryNoteModal />
          </ProtectedRoute>
        } />
        <Route path="/stockin" element={
          <ProtectedRoute screenCode="STOCK_IN">
            <StockInItems />
          </ProtectedRoute>
        } />
        <Route path="/stockout" element={
          <ProtectedRoute screenCode="STOCK_OUT">
            <StockOutItems />
          </ProtectedRoute>
        } />
        <Route path="/bc-api-mapping" element={
          <ProtectedRoute screenCode="API_MAPPING">
            <MappingMaster />
          </ProtectedRoute>
        } />
        <Route path="/company-information" element={
          <ProtectedRoute screenCode="COMPANY">
            <CompanyMaster company_id="C-001" />
          </ProtectedRoute>
        } />
        <Route path="/branch-master" element={
          <ProtectedRoute screenCode="BRANCH_MASTER">
            <BranchLocation />
          </ProtectedRoute>
        } />
<Route path="/session-service" element={
          <ProtectedRoute screenCode="SESSION_SERVICE">
            <SessionService />
          </ProtectedRoute>
        } />

        <Route path="/bill-of-material" element={
          <ProtectedRoute screenCode="BILL_OF_MATERIAL">
            <BOMMaster />
          </ProtectedRoute>
        } />
        <Route path="/stock-summary-report" element={
          <ProtectedRoute screenCode="STOCK_SUMMARY">
            <StockSummaryReport />
          </ProtectedRoute>
        } />
        <Route path="/department-master" element={
          <ProtectedRoute screenCode="DEPARTMENT_MASTER">
            <DepartmentMaster />
          </ProtectedRoute>
        } />

         <Route path="/production-order-master" element={
          <ProtectedRoute screenCode="PRODUCTION_ORDER">
            <ProductionOrderMaster />
          </ProtectedRoute>
        } />

          <Route path="/issue-for-production" element={
          <ProtectedRoute screenCode="ISSUE_FOR_PRODUCTION">
            <IssueForProductionItems />
          </ProtectedRoute>
        } />

        <Route path="/receipt-from-production" element={
          <ProtectedRoute screenCode="RECEIPT_FROM_PRODUCTION">
            <ReceiptFromProductionItems />
          </ProtectedRoute>
        } />

        <Route path="/survey-boq" element={
          <ProtectedRoute screenCode="SURVEY_BOQ">
            <SurveyBOQItems />
          </ProtectedRoute>
        } />

        <Route path="/project-list" element={
          <ProtectedRoute screenCode="PROJECT_LIST">
            <ProjectItems />
          </ProtectedRoute>
        } />

        <Route path="/feeder-list" element={
          <ProtectedRoute screenCode="FEEDER">
            <FeederList />
          </ProtectedRoute>
        } />

         <Route path="/site-indent" element={
          <ProtectedRoute screenCode="SITE_INDENT">
            <SiteIndentItems />
          </ProtectedRoute>
        } />

       <Route path="/approval-flow" element={
          <ProtectedRoute screenCode="APPROVAL_FLOW">
            <ApprovalMaster />
          </ProtectedRoute>
        } />

        <Route path="/material-issue" element={
          <ProtectedRoute screenCode="MATERIAL_ISSUE">
            <MaterialIssueItems />
          </ProtectedRoute>
        } />
        
        <Route path="/material-receive" element={
          <ProtectedRoute screenCode="MATERIAL_RECEIVE">
            <MaterialReceiveItems />
          </ProtectedRoute>
        } />

        <Route path="/dpr" element={
          <ProtectedRoute screenCode="DPR">
            <DPRItems />
          </ProtectedRoute>
        } />

        <Route path="/material-return" element={
          <ProtectedRoute screenCode="MATERIAL_RETURN">
            <MaterialReturnItems />
          </ProtectedRoute>
        } />
        <Route path="/comparison-report" element={
          <ProtectedRoute screenCode="COMPARISON_REPORT">
            <ComparisonReport />
          </ProtectedRoute>
        } />

         <Route path="/activity-list" element={
          <ProtectedRoute screenCode="ACTIVITY_LIST">
            <ActivityList />
          </ProtectedRoute>
        } />
        
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;